<template>
   € {{ formattedValue }}
</template>

<script>
export default {
    props: {
        value: {
            required: true, type: String
        }
    },
    computed: {
        formattedValue() {
            return this.value.replace('.', ',');
        }
    }
}
</script>